// extracted by mini-css-extract-plugin
export default {"inhecoScilaOpenDrawerDialog":"inhecoScilaOpenDrawerDialog-QQphT","text":"text-jdDzt","openDrawerMessage":"openDrawerMessage-Z__Dx"};